"use client";

import Layout from "@src/components/common/Layout";
import { selectAuthExpireError, selectAuthToken } from "@src/store/slices/login/selectors";
import Head from "next/head";

import PrivacyPolicyComponents from "../../components/PrivacyPolicy";

import { useAppSelector } from "@src/store/hooks";
const plataformName = `${process.env.NEXT_PUBLIC_PLATAFORM_NAME}`;

const onAuthLinks = [
  { label: "Página inicial", route: "/home" },
  { label: "Termos de uso", route: "/use-terms", active: true },
];

const offAuthLinks = [
  { label: "Login", route: "/login" },
  { label: "Termos de uso", route: "/use-terms", active: true },
];

const page = (isAuth: boolean) => {
  const isPrdEnv = process.env.NEXT_PUBLIC_ENVIRONMENT === "production";

  return (
    <PrivacyPolicyComponents
      idNotice={process.env.NEXT_PUBLIC_PRIVACY_NOTICE_ID_TERMS_OF_USE!}
      title="Termos de Uso"
      links={isAuth ? onAuthLinks : offAuthLinks}
      termUse={!isPrdEnv}
    />
  );
};

const TermsUse = () => {
  const authToken = useAppSelector(selectAuthToken);
  const authExpireError = useAppSelector(selectAuthExpireError);
  const isAuth = !!authToken && !authExpireError;
  const pageTitle = `${plataformName} | Termos de Uso`;

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      {isAuth ? <Layout>{page(isAuth)}</Layout> : page(isAuth)}
    </>
  );
};

export default TermsUse;
